import SelectedPassengerClassesType
    from "@CheckOrder/features/classPicker/types/selectedPassengerClass/SelectedPassengerClasses.type";
import entries from "@Object/entries";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

export default function preparePassengerClassesRequest(selectedPassengerClasses: SelectedPassengerClassesType) {
    const {
        passengerToPassengerClassMap,
        classToPassengersMap,
    } = selectedPassengerClasses

    const getPassengerClassFromTheNumberOfUsers = (passengerClass: AvailablePassengerClassType, userCount: number) => (
        passengerClass.ids[userCount]
    )

    const preparedSelectedPassengerClassesRequest = entries(classToPassengersMap).flatMap(([_passengerClassId, passengerIdsGroups]) => (
        passengerIdsGroups.map((passengerIdsGroup, index) => {
            const passengerClass = passengerToPassengerClassMap[passengerIdsGroup[0]]

            if (passengerClass.isDefault) {
                return null
            }

            const userCount = passengerIdsGroup.length

            return ({
                ...passengerClass,
                id: getPassengerClassFromTheNumberOfUsers(passengerClass, userCount),
                type: passengerClass.type,
                users: userCount,
                assignedPassengersIds: passengerIdsGroup,
                assignedPassengersGroupId: index,
            })
        })
    ))

    return preparedSelectedPassengerClassesRequest.filter((passengerClass) => (!!passengerClass))
}